import FrontEndApiService from './frontend.api.service';
import {runAsPublic} from "@helpers/api-helper";

const MarketingUrlService = {
    getJobData(query, authAction, fullUrl) {
        return {
            'full_url': fullUrl,
            'url_name': query.get('hsa_kw') || query.get('utm_term'),
            'email': query.get('email_address') || query.get('vyemail') || query.get('email') || query.get('token'),
            'event': authAction,
            'utm_source': query.get('utm_source') || query.get('hsa_src'),
            'utm_medium': query.get('utm_medium'),
            'utm_campaign': query.get('utm_campaign'),
            'utm_content': query.get('utm_content') || query.get('utm_term') || query.get('hsa_kw'),
            'reffering_platform': query.get('referringPlatform'),
            'type': query.get('type'),
            'network': query.get('network') || query.get('hsa_net'),
            'placement': query.get('placement'),
            'target': query.get('target') || query.get('hsa_tgt'),
            'cid': query.get('cid') || query.get('hsa_cam'),
            'agid': query.get('agid'),
            'tid': query.get('tid'),
            'mt': query.get('mt') || query.get('matchtype') || query.get('hsa_mt'),
            'pos': query.get('pos'),
            'extid': query.get('extid'),
            'device': query.get('device'),
            'loci': query.get('loci'),
            'locp': query.get('locp'),
            'adset': query.get('adset'),
            'aid': query.get('aid') || query.get('hsa_ad'),
            'sc': query.get('sc'),
            'third_party': query.get('third_party'),
            'medium_type': query.get('medium_type'),
            'linkname': query.get('linkname'),
            'ssid': query.get('ssid'),
            'broker': query.get('broker'),
            'state': query.get('state'),
            'license_id': query.get('license_id'),
            'email_address': query.get('email_address'),
            'first_name': query.get('first_name'),
            'last_name': query.get('last_name'),
            'nrds_id': query.get('nrds_id'),
            'vyemail': query.get('vyemail'),
            'v': query.get('v'),
        };
    },
    async createMarketingUrl(query, authAction, fullUrl) {
        try {
            if (query && authAction && fullUrl) {
                await runAsPublic(async (config) => {
                    await FrontEndApiService.post(`${config.apiPrefix}/${config.apiVersion}/url/create`, {
                        jobData: JSON.stringify(MarketingUrlService.getJobData(query, authAction, fullUrl)),
                    });
                });
            }
        } catch (error) {
            console.error(error);
            return false;
        }
        return true;
    }
};

export default MarketingUrlService;